/**
 *
 * @param enumerator
 * @returns Enum keys as a list
 */
export var getEnumKeys = function (enumerator) {
    return Object.keys(enumerator).filter(function (val) { return isNaN(Number(val)) === true; });
};
